var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 12H8.66675V11.3333C8.66675 10.8029 8.87746 10.2942 9.25253 9.91912C9.62761 9.54405 10.1363 9.33333 10.6667 9.33333H10.7807C10.9191 8.94366 11.1747 8.60634 11.5123 8.36763C11.85 8.12892 12.2532 8.0005 12.6667 8H19.3334C19.7469 8.0005 20.1502 8.12892 20.4878 8.36763C20.8255 8.60634 21.081 8.94366 21.2194 9.33333H21.3334C21.8638 9.33333 22.3726 9.54405 22.7476 9.91912C23.1227 10.2942 23.3334 10.8029 23.3334 11.3333V12ZM14.6667 18.6667C14.7367 21.3027 17.2634 21.302 17.3334 18.6667C17.2667 16.0307 14.7367 16.0313 14.6667 18.6667ZM13.3874 18C13.9821 14.4753 18.0194 14.4773 18.6127 18H22.0054L22.5887 13.3333H9.41141L9.99475 18H13.3874ZM18.6127 19.3333C18.0181 22.858 13.9814 22.856 13.3874 19.3333H10.1614L10.7447 24H21.2554L21.8387 19.3333H18.6127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeverage);
export default __webpack_public_path__ + "static/media/beverage.6b0c3d5e2a104962393a58d60a5bcd3c.svg";
export { ForwardRef as ReactComponent };